import React from 'react';
import { FaApple, FaGooglePlay, FaGlobe, FaDesktop } from 'react-icons/fa';

const iconMap = {
  web: { Icon: FaGlobe, label: 'Web' },
  ios: { Icon: FaApple, label: 'iOS' },
  android: { Icon: FaGooglePlay, label: 'Android' },
  desktop: { Icon: FaDesktop, label: 'Desktop' },
};

const PlatformIcons = ({ platforms = [], size = 'sm' }) => {
  if (platforms.length === 0) return null;
  const s = size === 'lg' ? 'w-4 h-4' : 'w-3 h-3';
  const wrap = size === 'lg' ? 'w-7 h-7' : 'w-6 h-6';

  return (
    <div className="flex items-center gap-1">
      {platforms.map((p) => {
        const meta = iconMap[p];
        if (!meta) return null;
        const { Icon, label } = meta;
        return (
          <span
            key={p}
            title={label}
            className={`inline-flex items-center justify-center ${wrap} rounded-md bg-primary-50 text-primary-600 ring-1 ring-primary-100`}
          >
            <Icon className={s} />
          </span>
        );
      })}
    </div>
  );
};

export default PlatformIcons;
